import { endOfDay } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';

/**
 * Given a timestamp like '2021-04-01', create a date instance that is offset by the user's timezone
 * to either the exact start or end of the day.
 * @param timestamp - a date string like '2021-04-01', or null
 * @param type - either 'end' or 'start'
 * @returns - a Date if timestamp was a string, or null if timestamp was null
 */
export const getGapAnalysisDate = (
    timestamp: string | null,
    type: 'end' | 'start',
): Date | null => {
    if (timestamp === null) {
        return null;
    }
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    try {
        const zonedTime = utcToZonedTime(timestamp, timezone);

        if (type === 'start') {
            return zonedTime;
        }

        return endOfDay(zonedTime);
    } catch (error) {
        return null;
    }
};
